import React from "react";
import { useLang } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee") || [];
  const row = [...items, ...items, ...items];
  return (
    <section className="bg-[#EFEBE6] py-10 lg:py-14 overflow-hidden border-y border-[#DCD7D1]" data-testid="marquee-section">
      <div className="relative">
        <div className="flex gap-12 animate-marquee whitespace-nowrap" style={{ width: "max-content" }}>
          {row.map((it, i) => (
            <span
              key={i}
              className="font-display text-5xl lg:text-7xl font-light tracking-tighter text-[#1A1A1A]/85"
            >
              {it}
              <span className="text-[#8A5A44] mx-8">●</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
